module.exports = __webpack_public_path__ + "img/bg_avatar_female_45.baf13de0.png";